[
  { "id": "schlammpfuetze", "name": "Schlammpfütze", "difficulty": 1, "concept": ["G18", "K7"], "placeholder": true,
    "enemies": [
      { "enemy": "schlammling", "x": 96, "y": 22 },
      { "enemy": "schlammling", "x": 104, "y": 36, "traits": ["unruhig"] },
      { "enemy": "schlammling", "x": 118, "y": 28 },
      { "enemy": "windschnitt", "x": 130, "y": 80 },
      { "enemy": "windschnitt", "x": 142, "y": 62 }
    ] },
  { "id": "hagelschauer", "name": "Hagel von hinten", "difficulty": 2, "concept": ["G18", "K7"], "placeholder": true,
    "enemies": [
      { "enemy": "schlammling", "x": 94, "y": 72 },
      { "enemy": "schlammling", "x": 100, "y": 86, "traits": ["traege"] },
      { "enemy": "schlammling", "x": 110, "y": 64 },
      { "enemy": "hagelchen", "x": 138, "y": 20 },
      { "enemy": "hagelchen", "x": 150, "y": 34, "traits": ["feige"] }
    ] },
  { "id": "treibgut", "name": "Treibgut", "difficulty": 3, "concept": ["G18", "G17", "K7"], "placeholder": true,
    "enemies": [
      { "enemy": "treibholzer", "x": 102, "y": 66, "traits": ["zaeh"] },
      { "enemy": "schlammling", "x": 92, "y": 18 },
      { "enemy": "schlammling", "x": 108, "y": 30 },
      { "enemy": "hagelchen", "x": 146, "y": 82 }
    ] },
  { "id": "windschneise", "name": "Windschneise", "difficulty": 4, "concept": ["G18", "K13", "K7"], "placeholder": true,
    "enemies": [
      { "enemy": "treibholzer", "x": 106, "y": 28 },
      { "enemy": "schlammling", "x": 94, "y": 46, "traits": ["wuetend"] },
      { "enemy": "windschnitt", "x": 134, "y": 12, "traits": ["wuetend"] },
      { "enemy": "windschnitt", "x": 112, "y": 88 }
    ] },
  { "id": "sturmfront", "name": "Sturmfront", "difficulty": 5, "concept": ["G18", "G17", "K7"], "placeholder": true,
    "enemies": [
      { "enemy": "treibholzer", "x": 100, "y": 70, "traits": ["fanatisch"] },
      { "enemy": "schlammling", "x": 92, "y": 40 },
      { "enemy": "windschnitt", "x": 128, "y": 14 },
      { "enemy": "windschnitt", "x": 140, "y": 56, "traits": ["feige"] },
      { "enemy": "hagelchen", "x": 150, "y": 30 }
    ] }
]
